// extracted by mini-css-extract-plugin
export default {"link":"I6skQ","noUnderline":"pCFNw","normal":"gKEUh","dark":"npZAP","white":"orEoY","arrow":"h0DBC"};